import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getWorkflowCase,
  listWorkflowCases,
  updateSubStepApprovalWithoutStagesNote,
} from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/** Updates the current approval note that is independent of a stage number. */
export function useUpdateSubStepApprovalWithoutStagesNote(
  caseId: string,
): InvalidatingMutationResultFor<
  typeof updateSubStepApprovalWithoutStagesNote
> {
  return useInvalidatingMutation(updateSubStepApprovalWithoutStagesNote, [
    createConnectQueryKey({
      schema: getWorkflowCase,
      cardinality: 'finite',
      input: { id: caseId },
    }),
    createConnectQueryKey({ schema: listWorkflowCases, cardinality: 'finite' }),
  ])
}
